import instanceAPI from 'services/apis/axiosconfig';

export const getCategoriesAndExperiences = () => {
  const request = instanceAPI.get('/public/get-categories-and-experiences');
  return request.then((res) => ({
    ...res,
    data: {
      results: {
        categories: res.data.categories,
        experiences: res.data.experiences,
      },
    },
  }));
};
